import request from "./request";
import URLS from "../configurations/urls";
import Api from "./Api";

class ArbiterApi extends Api {
  static getReasonCodes(params = {}) {
    console.log(Api.HTTP_OPTIONS);
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_REASON_CODES}`;
    options.params = params;
    return request.get(options);
  }

  static updateReasonCode(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_REASON_CODES}/${id}`;
    options.data = data;
    return request.patch(options);
  }
  static createReasonCode(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_REASON_CODES;
    options.data = data;
    return request.post(options);
  }
  static getReasonCodesByCategory(category) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_CATEGORIES}/${category}/reasons`;
    options.params = {};
    return request.get(options);
  }

  static getTransactionGroups() {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTIONS_GROUPS}`;
    options.params = {};
    return request.get(options);
  }

  static getPaginatedTransactionGroups(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_GROUPS}`;
    options.params = params;
    return request.get(options);
  }
  static updateTransactionGroup(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_GROUPS}/${id}`;
    options.data = data;
    return request.patch(options);
  }
  static createTransactionGroup(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_TRANSACTION_GROUPS;
    options.data = data;
    return request.post(options);
  }

  static getDisputeRegions(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTE_REGIONS}`;
    options.params = params;
    return request.get(options);
  }
  static updateDisputeRegion(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTE_REGIONS}/${id}`;
    options.data = data;
    return request.patch(options);
  }
  static createDisputeRegion(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_DISPUTE_REGIONS;
    options.data = data;
    return request.post(options);
  }

  static getDisputeAcquirers(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_ACQUIRERS}`;
    options.params = params;
    return request.get(options);
  }
  static getDisputeIssuers(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_ISSUERS}`;
    options.params = params;
    return request.get(options);
  }
  static getDisputeMerchants(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_MERCHANTS}`;
    options.params = params;
    return request.get(options);
  }

  static getTransactionTypes(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_TYPE}`;
    options.params = params;
    return request.get(options);
  }
  static updateTransactionType(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_TYPE}/${id}`;
    options.data = data;
    return request.patch(options);
  }
  static createTransactionType(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_TRANSACTION_TYPE;
    options.data = data;
    return request.post(options);
  }

  static getDisputeCategories() {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_CATEGORIES}`;
    options.params = {};
    return request.get(options);
  }

  static getDisputeCategoriesBulk() {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTES_CATEGORIES_BULK}`;
    options.params = {};
    return request.get(options);
  }

  static getTransactionTimelines(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}`;
    options.params = params;
    return request.get(options);
  }

  static createTransactionTimeline(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_TRANSACTION_TIMELINES;
    options.data = data;
    return request.post(options);
  }

  static updateTransactionTimeline(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}/${id}`;
    options.data = data;
    return request.patch(options);
  }

  static deleteTransactionTimeline(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}/${id}`;
    return request.delete(options);
  }

  static getDisputeTimelines(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}`;
    options.params = params;
    return request.get(options);
  }

  static createDisputeTimeline(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_DISPUTE_TIMELINES;
    options.data = data;
    return request.post(options);
  }

  static updateDisputeTimeline(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}/${id}`;
    options.data = data;
    return request.patch(options);
  }

  static deleteDisputeTimeline(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}/${id}`;
    return request.delete(options);
  }

  static getSettingsConfigTypes(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTINGS_CONFIG_TYPES}`;
    options.params = params;
    return request.get(options);
  }

  static createSettingsConfig(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_SETTINGS_CONFIG;
    options.data = data;
    return request.post(options);
  }

  static getSettingsConfig(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTINGS_CONFIG}`;
    options.params = params;
    return request.get(options);
  }

  static getSettingsConfigByType(params = {}, type) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTINGS_CONFIG_BY_TYPE}/${type}`;
    options.params = params;
    return request.get(options);
  }

  static updateSettingsConfig(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTINGS_CONFIG}/${id}`;
    options.data = data;
    return request.patch(options);
  }
  static deleteSettingsConfig(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTINGS_CONFIG}/${id}`;
    return request.delete(options);
  }

  static getMerchantDisputants(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}`;
    options.params = params;
    return request.get(options);
  }

  static getMerchantDisputant(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}/${id}`;
    return request.get(options);
  }

  static createMerchantDisputant(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_MERCHANT_DISPUTANTS;
    options.data = data;
    return request.post(options);
  }

  static updateMerchantDisputant(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}/${id}`;
    options.data = data;
    return request.patch(options);
  }

  static deleteMerchantDisputant(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}/${id}`;
    return request.delete(options);
  }

  static getCardAcceptors(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_CARD_ACCEPTOR}/${id}`;
    return request.get(options);
  }
  static createCardAcceptor(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_CARD_ACCEPTOR}/${id}`;
    options.data = data;
    return request.post(options);
  }

  static getCountries(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_GET_COUNTRIES}`;
    options.params = params;
    return request.get(options);
  }

  static getSettlementRuleLabels(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_GET_SETTLEMENT_RULES_LABEL}`;
    options.params = params;
    return request.get(options);
  }

  static getSettlementRules(params = {}) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTLEMENT_RULES}`;
    options.params = params;
    return request.get(options);
  }

  static createSettlementRule(data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.ARBITER_API_SETTLEMENT_RULES;
    options.data = data;
    return request.post(options);
  }

  static updateSettlementRule(id, data) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTLEMENT_RULES}/${id}`;
    options.data = data;
    return request.patch(options);
  }

  static deleteSettlementRule(id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SETTLEMENT_RULES}/${id}`;
    return request.delete(options);
  }
}

export default ArbiterApi;



// WEBPACK FOOTER //
// ./src/api/ArbiterApi.js